<app-card
  [partialFullHeight]="true"
  size="large"
  [spacingBottom]="Spacing.NONE"
>
  @if (tenant?.features?.advancedSupport?.value) {
  <app-view
    [spacingBottom]="24"
    data-test-id="account-support-technical-manager-view"
  >
    <app-title-section
      [size]="2"
      [title]="'account.technicalManager' | translate"
      [subTitle]="technicalManager?.name ?? ('common.name' | translate)"
      [body]="
        (technicalManager?.email ?? ('common.email' | translate)) +
        ', ' +
        (technicalManager?.phone ?? ('common.phone' | translate))
      "
    ></app-title-section>
  </app-view>
  } @if (tenant?.features?.clientSuccess?.value) {
  <app-view data-test-id="customer-manager-title">
    <app-title-section
      [size]="2"
      [spacingBottom]="24"
      [title]="'account.customerManager' | translate"
      [subTitle]="customerManager?.name ?? ('common.name' | translate)"
      [body]="
        (customerManager?.email ?? ('common.email' | translate)) +
        ', ' +
        (customerManager?.phone ?? ('common.phone' | translate))
      "
    ></app-title-section>
  </app-view>
  } @if ( !tenant?.features?.advancedSupport?.value &&
  !tenant?.features?.clientSuccess?.value ) {
  <app-view
    [spacingBottom]="24"
    [direction]="ViewDirection.COLUMN"
    data-test-id="account-support-manager-resource-view"
  >
    <app-title-section
      [size]="2"
      [spacingBottom]="24"
      [title]="'account.supportTitle' | translate"
      [subTitle]="'account.supportSubtitle' | translate"
    ></app-title-section>

    <app-title-section
      [size]="2"
      [spacingBottom]="24"
      [title]="'account.enterpriseContactList' | translate"
      [subTitle]="'account.enterpriseContactListSubtitle' | translate"
    ></app-title-section>
    <app-button
      [type]="ButtonType.PRIMARY"
      (handleClick)="openContactList()"
      data-test-id="contact-list-button"
      >{{ 'account.contactList' | translate }}</app-button
    >
    <app-title-section
      [size]="2"
      [spacingBottom]="24"
      [title]="'account.enterpriseSupportForm' | translate"
      [subTitle]="'account.enterpriseSupportFormSubtitle' | translate"
    ></app-title-section>
    <app-button
      [type]="ButtonType.PRIMARY"
      (handleClick)="submitSupportRequest()"
      data-test-id="account-support-request-button"
      >{{ 'account.supportRequest' | translate }}</app-button
    >
  </app-view>
  }
</app-card>
